import { render } from "./GuarantorInsurance.vue?vue&type=template&id=c05ed342"
import script from "./GuarantorInsurance.vue?vue&type=script&lang=js"
export * from "./GuarantorInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/orders/billingInfo/forms/GuarantorInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c05ed342"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c05ed342', __exports__)) {
    console.log('reload')
    api.reload('c05ed342', __exports__)
  }
  
  module.hot.accept("./GuarantorInsurance.vue?vue&type=template&id=c05ed342", () => {
    console.log('re-render')
    api.rerender('c05ed342', render)
  })

}


export default __exports__